import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dropzone from "react-dropzone";
import IconButton from "@material-ui/core/IconButton";
import ImageIcon from "@material-ui/icons/PhotoCamera";
import VideoIcon from "@material-ui/icons/Videocam";
import UploadIcon from "@material-ui/icons/CloudUpload";
import FailIcon from "@material-ui/icons/CloudOff";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import CircularProgress from "@material-ui/core/CircularProgress";
import purple from "@material-ui/core/colors/purple";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { campaignService } from "../_services";
import { alertActions } from "../_actions";

const styles = theme => ({
    container: {
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexDirection: "column"
    },
    segment: {
        alignSelf: "left",
        marginBottom: 25,
        borderRadius: 5,
        border: "1px solid gray",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    button: {
        width: 40,
        height: 40,
        borderRadius: 0
    },
    buttonIcon: {
        width: 21,
        height: 21
    },
    divider: {
        width: 1,
        height: 20,
        backgroundColor: "gray"
    },
    uploadArea: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        overflow: "hidden"
    },
    dropzone: {
        width: 100,
        height: 100,
        border: "1px dashed gray",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    img: {
        maxWidth: "100%",
        maxHeight: "100%"
    }
});

const FILE_TYPES = {
    IMG: "image/jpeg, image/png",
    VIDEO: "video/mp4"
};

const FILE_SIZE = {
    MB_1: 1048576,
    MB_2: 2097152,
    MB_5: 5242880,
    MB_30: 31457280,
    MB_100: 104857600
};

export const EMPTY_BANNER_DATA = {};

export const validateBannerData = bannerData => {
    return bannerData.thumbnail_small &&
        bannerData.thumbnail_medium &&
        bannerData.url
        ? true
        : false;
};

//#region CDropzone
class CustomDropzone extends React.Component {
    IMAGE_STATE = {
        EMPTY: 0,
        RESTRICTED: 1,
        UPLOADING: 2,
        FAIL: 3,
        SUCCESS: EMPTY_BANNER_DATA
    };

    constructor(props) {
        super(props);

        let hasData = validateBannerData(props.bannerData);
        this.IMAGE_STATE.SUCCESS = hasData
            ? props.bannerData
            : EMPTY_BANNER_DATA;
        this.state = {
            bannerData: hasData
                ? this.IMAGE_STATE.SUCCESS
                : this.IMAGE_STATE.EMPTY,
            hoverOn: false
        };
    }

    onDropBanner(acceptedFiles) {
        if (acceptedFiles.length > 0) {
            this.setState({ bannerData: this.IMAGE_STATE.UPLOADING });

            let file = acceptedFiles[0];

            campaignService.uploadBanner(file).then(
                bannerData => {
                    this.IMAGE_STATE.SUCCESS = bannerData;
                    this.setState({ bannerData: this.IMAGE_STATE.SUCCESS });

                    this.props.onChange(this.props.imgKey, bannerData);
                },
                error => {
                    this.setState({ bannerData: this.IMAGE_STATE.FAIL });

                    this.props.onChange(this.props.imgKey, EMPTY_BANNER_DATA);

                    this.props.dispatch(alertActions.error(error));
                }
            );
        } else {
            this.setState({ bannerData: this.IMAGE_STATE.EMPTY });

            this.props.onChange(this.props.imgKey, EMPTY_BANNER_DATA);
        }
    }

    onDropRejected(rejectedFiles) {
        this.setState({ bannerData: this.IMAGE_STATE.RESTRICTED });

        this.props.onChange(this.props.imgKey, EMPTY_BANNER_DATA);
    }

    onRemove(e) {
        e.stopPropagation();

        campaignService.removeBanner(this.props.bannerData.url)

        this.setState({ bannerData: this.IMAGE_STATE.EMPTY });

        this.props.onChange(this.props.imgKey, EMPTY_BANNER_DATA);
    }

    onView(e) {
        e.stopPropagation();

        this.props.onView(this.props.imgKey);
    }

    render() {
        const { classes } = this.props;
        const self = this;

        function renderContent() {
            const mainContentStyle = {
                flex: "0 0 100%",
                height: "100%",
                overflow: "hidden"
                // backgroundColor: "rgba(255, 0, 0, 0.2)"
            };
            const buttonStyle = { color: "white" };
            let mainContent =
                self.props.acceptTypes === FILE_TYPES.IMG ? (
                    <img
                        style={mainContentStyle}
                        src={self.state.bannerData.thumbnail_small}
                        alt="Banner"
                    />
                ) : (
                    <VideoIcon style={mainContentStyle} />
                );

            let hoverContent = (
                <div
                    style={{
                        display: "flex",
                        height: "100%",
                        width: "100%",
                        alignItems: "center"
                    }}
                >
                    {mainContent}
                    <div
                        style={{
                            flex: "100%",
                            height: "100%",
                            marginLeft: "calc(-50% - (100% / 2))",
                            backgroundColor: "rgba(0, 0, 0, 0.5)"
                        }}
                    >
                        <IconButton
                            style={buttonStyle}
                            aria-label="Remove"
                            onClick={event => self.onRemove(event)}
                        >
                            <CloseIcon />
                        </IconButton>
                        <IconButton
                            style={buttonStyle}
                            aria-label="View"
                            onClick={event => self.onView(event)}
                        >
                            <EyeIcon />
                        </IconButton>
                    </div>
                </div>
            );

            let content = self.state.hoverOn ? hoverContent : mainContent;

            return content;
        }

        let content = null;
        switch (this.state.bannerData) {
            case this.IMAGE_STATE.EMPTY:
                content = <UploadIcon />;
                break;
            case this.IMAGE_STATE.RESTRICTED:
                content = <ErrorIcon />;
                break;
            case this.IMAGE_STATE.UPLOADING:
                content = (
                    <CircularProgress
                        className={classes.progress}
                        style={{ color: purple[500] }}
                        thickness={7}
                    />
                );
                break;
            case this.IMAGE_STATE.FAIL:
                content = <FailIcon />;
                break;
            case this.IMAGE_STATE.SUCCESS:
                content = renderContent();

                break;
            default:
                break;
        }

        return (
            <Dropzone
                className={classes.dropzone}
                accept={this.props.acceptTypes}
                maxSize={this.props.maxSize}
                onDrop={files => this.onDropBanner(files)}
                onDropRejected={files => this.onDropRejected(files)}
                onMouseEnter={() => this.setState({ hoverOn: true })}
                onMouseLeave={() => this.setState({ hoverOn: false })}
            >
                {content}
            </Dropzone>
        );
    }
}

CustomDropzone.propTypes = {
    classes: PropTypes.object.isRequired
};

const CDropzone = withStyles(styles)(CustomDropzone);
//#endregion CDropzone

class UploadBannerComponent extends React.Component {
    constructor(props) {
        super(props);

        function normalizeUrlForKey(key) {
            let result =
                props.mediaData &&
                props.mediaData[key] &&
                validateBannerData(props.mediaData[key])
                    ? props.mediaData[key]
                    : EMPTY_BANNER_DATA;

            return result;
        }

        this.state = {
            uploadImages:
                props.mediaData &&
                props.mediaData.video &&
                validateBannerData(props.mediaData.video)
                    ? false
                    : true,
            img1: normalizeUrlForKey("img1"),
            img2: normalizeUrlForKey("img2"),
            img3: normalizeUrlForKey("img3"),
            video: normalizeUrlForKey("video"),
            galleryIndex: 0,
            isOpenLightBox: false
        };
    }

    //#region public
    getUploadedItems() {
        let uploadedItems = {
            img1: this.state.img1,
            img2: this.state.img2,
            img3: this.state.img3,
            video: this.state.video
        };

        return uploadedItems;
    }
    //#endregion public

    //#region actions
    onFileChange(key, bannerData) {
        this.setState({ [key]: bannerData });
    }

    switchUploadImages(isUploadingImages) {
        this.setState({ uploadImages: isUploadingImages });
    }
    //#endregion actions

    //#region render
    openGalleryForKey(key) {
        // create array
        let imgArray = [];
        let noImgUrl =
            "https://www.hakema.net/app/webroot/img/frontend/warning.png";
        if (validateBannerData(this.state.img1)) {
            imgArray.push(this.state.img1.url);
        } else {
            imgArray.push(noImgUrl);
        }
        if (validateBannerData(this.state.img2)) {
            imgArray.push(this.state.img2.url);
        } else {
            imgArray.push(noImgUrl);
        }
        if (validateBannerData(this.state.img3)) {
            imgArray.push(this.state.img3.url);
        } else {
            imgArray.push(noImgUrl);
        }
        if (validateBannerData(this.state.video)) {
            imgArray.push(this.state.video.url);
        } else {
            imgArray.push(noImgUrl);
        }

        // index
        let index = 0;
        if (key === "img1") {
            index = 0;
        } else if (key === "img2") {
            index = 1;
        } else if (key === "img3") {
            index = 2;
        } else {
            index = 3;
        }

        // open light box
        this.setState({
            galleryArray: imgArray,
            galleryIndex: index,
            isOpenLightBox: true
        });
    }

    renderImageGallery() {
        const { galleryArray, galleryIndex, isOpenLightBox } = this.state;

        return (
            <div>
                {isOpenLightBox && galleryArray && (
                    <Lightbox
                        mainSrc={galleryArray[galleryIndex]}
                        nextSrc={galleryArray[(galleryIndex + 1) % galleryArray.length]}
                        prevSrc={
                            galleryArray[
                                (galleryIndex + galleryArray.length - 1) %
                                galleryArray.length
                            ]
                        }
                        onCloseRequest={() =>
                            this.setState({ isOpenLightBox: false })
                        }
                        onMovePrevRequest={() =>
                            this.setState({
                                galleryIndex:
                                    (galleryIndex + galleryArray.length - 1) %
                                    galleryArray.length
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                galleryIndex: (galleryIndex + 1) % galleryArray.length
                            })
                        }
                    />
                )}
            </div>
        );
    }

    render() {
        const { classes } = this.props;
        const self = this;
        const state = this.state;

        function renderSegment() {
            return (
                <div className={classes.segment}>
                    <IconButton
                        className={classes.button}
                        style={{ color: state.uploadImages ? "black" : "gray" }}
                        aria-label="Images"
                        onClick={() => self.switchUploadImages(true)}
                    >
                        <ImageIcon className={classes.buttonIcon} />
                    </IconButton>
                    <div className={classes.divider} />
                    <IconButton
                        className={classes.button}
                        style={{ color: state.uploadImages ? "gray" : "black" }}
                        aria-label="Video"
                        onClick={() => self.switchUploadImages(false)}
                    >
                        <VideoIcon className={classes.buttonIcon} />
                    </IconButton>
                </div>
            );
        }

        function renderUploadArea() {
            function renderImageDropZone(imgKey) {
                return (
                    <CDropzone
                        imgKey={imgKey}
                        acceptTypes={FILE_TYPES.IMG}
                        maxSize={FILE_SIZE.MB_1}
                        bannerData={state[imgKey]}
                        onChange={(imgKey, bannerData) =>
                            self.onFileChange(imgKey, bannerData)
                        }
                        onView={imgKey => self.openGalleryForKey(imgKey)}
                    />
                );
            }

            let images = (
                <div
                    className={classes.uploadArea}
                    style={{ height: self.state.uploadImages ? "auto" : 0 }}
                >
                    {renderImageDropZone("img1")}
                    {renderImageDropZone("img2")}
                    {renderImageDropZone("img3")}
                </div>
            );

            let video = (
                <div
                    className={classes.uploadArea}
                    style={{ height: self.state.uploadImages ? 0 : "auto" }}
                >
                    <CDropzone
                        imgKey={"video"}
                        acceptTypes={FILE_TYPES.VIDEO}
                        maxSize={FILE_SIZE.MB_30}
                        bannerData={state.video}
                        onChange={(key, bannerData) =>
                            self.onFileChange(key, bannerData)
                        }
                        onView={imgKey => self.openGalleryForKey(imgKey)}
                    />
                </div>
            );

            return (
                <div>
                    {images}
                    {video}
                </div>
            );
        }

        return (
            <div className={classes.container}>
                {renderSegment()}
                {renderUploadArea()}
                {this.renderImageGallery()}
            </div>
        );
    }
    //#endregion render
}

UploadBannerComponent.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UploadBannerComponent);



// WEBPACK FOOTER //
// ./src/AddCampaignPage/UploadBannerComponent.js